import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
  selector: 'app-recovery-item-row',
  templateUrl: './recovery-item-row.component.html',
  styleUrls: ['./../base-row.component.scss'],
  standalone: false

})
export class RecoveryItemRowComponent extends BaseRow {

}
